import { formatDate, formatTime } from '../../Helpers/date-time-formatters';
import { fromLocalPhone } from '../../Helpers/phone-formatter';
import useTranslate from '../../Hooks/useTranslate';
import Text from '../../Style-guide/Text';
import Title from '../../Style-guide/Title';

const HistoryDisplay = ({ data }) => {
  const reservationsHistory = data || [];
  const tr = useTranslate();

  const grouped = reservationsHistory.reduce((acc, item) => {
    const key = item.startTime.split('T')[0];
    if (!acc[key]) acc[key] = [];
    acc[key].push(item);

    return acc;
  }, {});

  return (
    <section className='reservations-history-container'>
      <Title size='MD' className='reservations-history-title'>
        {tr('reservations_history')}
      </Title>
      <div className='reservations-history-content'>
        {Object.entries(grouped).map(([date, items], dateIndex) => {
          const formattedDate = formatDate(new Date(date));

          return (
            <div key={dateIndex} className='reservation-history-group'>
              <Text size='MD' className='reservation-history-date'>
                {formattedDate}
              </Text>

              {items.map((reservation, index) => {
                const { startTime, endTime, status, user } = reservation;

                const isCancelled = status === 'cancelled';
                const formattedStartTime = formatTime(new Date(startTime));
                const formattedEndTime = formatTime(new Date(endTime));

                return (
                  <div key={index} className='reservation-history-row'>
                    <Text size='SM' className='reservation-time'>
                      {formattedStartTime} - {formattedEndTime}
                    </Text>

                    <Text
                      size='SM'
                      className={`reservation-status${isCancelled ? ' status-cancelled' : ''}`}
                    >
                      {tr(status)}
                    </Text>

                    <Text size='SM' className='reservation-user'>
                      {user.firstName} {user.lastName} (0{fromLocalPhone(user.phone)})
                    </Text>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default HistoryDisplay;
